import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { closedCoworkingAdModal } from '../../../../serp/state/coworking_experiments/coworkingAdModal';

import { IAppState } from '../../../state';

import { CoworkingModalAd as CoworkingModalAdComponent } from './CoworkingModalAd';

export const CoworkingModalAd: React.FC = () => {
  const isOpen = useSelector<IAppState, boolean>(state => state.coworkingExperiments.coworkingAdModal.isOpen);

  const dispatch = useDispatch();
  const onClose = React.useCallback(() => {
    dispatch(closedCoworkingAdModal());
  }, []);

  return <CoworkingModalAdComponent open={isOpen} onClose={onClose} />;
};

CoworkingModalAd.displayName = 'CoworkingModalAd';
